import React, { useContext, useEffect } from 'react'
import { GeneralContext } from '../../context/'
import {
    Container,
} from "reactstrap"

import { withRouter } from 'react-router-dom'
import Form from './components/Form'

const Create = () => {
    const generalContext = useContext(GeneralContext)
    const { setBreadcrumb } = generalContext

    useEffect(() => {
        setBreadcrumb({
            icon: '',
            parent: `Marcas`,
            parentLink: '/brands',
            item: `Agregar marca`
        })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return(
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Form />
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withRouter(Create)
